import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_51_0 = () => {
  return (
    <div>
      <PageTitle title='3.51.0' />

      <ParaTitle paraTitle='Event Summary Updates' />
      <Paragraph paragraph='2026-06-04' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
        Attachment pill badges 
          <p>Add a visible indicator on the event list/detail page to show when an event contains attachments, so users can identify it at a glance. This reduces the chance of missing supporting materials during review and improves overall review efficiency.</p>
        </li>
        <li>Print event summary updates
          <p>Add a new official display option for event summaries (without comments, styled similarly to PSWP), update summary page titles, and include the Event ID in the title. This enables clearer, standardized report generation and separates printed/exported views from interactive views for users who need formal event documentation.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Multiple domains in docker container 
          <p>Enable support for routing multiple domains to the same Docker container in production. This ensures seamless domain transition and prepares the system for future domain changes without service disruption.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
        Null timeout redirection
          <p>Fix session timeout behavior so that when users are automatically logged out due to inactivity, they are redirected to the login page instead of a null/blank page. This ensures a smoother re-authentication flow after session expiry.</p>
        </li>
        <li>Dashboards with Directors not rendering
          <p>Fix an issue where dashboards display an error when certain reviewers (e.g., directors) are associated with an event. The dashboard now loads normally and show the Event Dashboard when accessing events with these reviewer roles.</p>
        </li>
        <li>Approver issue with approving events
          <p>Investigate and fix an issue where users are unable to close events. This record is required for the system to recognize the user as an assigned approver. Identify the root cause, reproduce the issue, and implement preventive measures to avoid similar data integrity problems in the future.</p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.52.0', link: '/updates/3.52.0' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_51_0;